// showErrorAlertに変更
export const showApiErrorAlert = (status: number, apiTitle: string) => {
    alert(apiTitle + "に失敗しました\nしばらくしてから再度お試しください。問題が解消しない場合は、サポートにお問い合わせください。\nエラーコード：" + status);
}